module.exports = __webpack_public_path__ + "img/sun-with-clouds-littlesnow.2c31feaa.png";